import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import DefaultProfileImage from "../../Components/Common/DefaultProfileImage";
const avatar1 = '';

const ProfileDropdown = () => {
	const selectUserData = createSelector((state) => state.Login, (state) => state.user);
	const user = useSelector(selectUserData);

	//Dropdown Toggle
	const [isProfileDropdown, setIsProfileDropdown] = useState(false);
	const toggleProfileDropdown = () => {
		setIsProfileDropdown(!isProfileDropdown);
	};
	return (
		<React.Fragment>
			<Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
				<DropdownToggle tag="button" type="button" className="btn">
					<span className="d-flex align-items-center">
						{user?.data.hasOwnProperty('picture') && user.data?.picture ?
							<img className="rounded-circle header-profile-user" src={user.data?.picture}
								alt="Header Avatar" draggable="false" />
							:
							<DefaultProfileImage firstName={user.data.firstName} lastName={user.data.lastName} />
						}
						<span className="text-start ms-xl-2">
							<span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
								{user?.data.firstName !== undefined && user?.data.firstName + " " + user?.data.lastName || ""}
							</span>
							<span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{(user?.data.role || "")}</span>
						</span>
					</span>
				</DropdownToggle>
				<DropdownMenu className="dropdown-menu-end">
					<h6 className="dropdown-header text-body">Welcome {(user?.data.firstName || "")}!</h6>
					{/* <DropdownItem className='p-0'>
						<Link to={process.env.PUBLIC_URL + "/"} className="dropdown-item">
							<i
								className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
									className="align-middle">Help</span>
						</Link>
					</DropdownItem> */}
					<div className="dropdown-divider"></div>
					<DropdownItem className='p-0'>
						<Link to={process.env.PUBLIC_URL + "/settings"} className="dropdown-item">
							<i
								className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
									className="align-middle">Settings</span>
						</Link>
					</DropdownItem>
					{/* <DropdownItem className='p-0'>
						<Link to={process.env.PUBLIC_URL + "/lockscreen"} state={{ user: user?.data }} className="dropdown-item">
							<i
								className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>  <span className="align-middle">Lock screen</span>
						</Link>
					</DropdownItem> */}
					<DropdownItem className='p-0'>
						<Link to={process.env.PUBLIC_URL + "/auth-logout"} className="dropdown-item">
							<i
								className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
									className="align-middle" data-key="t-logout">Logout</span>
						</Link>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default ProfileDropdown;